'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProjectNewCtrl
 * @description
 * # ProjectNewCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('ProjectNewCtrl', [
  '$scope', '$rootScope', '$state', '$stateParams', 'Project', 'GoogleApi', '$mdDialog',
   'Client', 'ProjectTypeCatalog', 'ProductCatalog', 'Employee', 'toaster','Pagination', '$q',
  function ($scope, $rootScope, $state, $stateParams, Project, GoogleApi, $mdDialog,
    Client, ProjectTypeCatalog, ProductCatalog, Employee, toaster, Pagination, $q,) {

    $scope.clientList = [];
    $scope.rapeList = [];
    $scope.pmList = [];
    $scope.projectTypeList = [];
    $scope.projectHash = {
      project: {
      }
    };
    $scope.currentProjectName;
    $scope.currentDriveId;
    $rootScope.isPicked = false;

    if($stateParams.projectId) {
      Project.find($stateParams.projectId).then(function(response) {
        $scope.projectHash = { 'project': response.data.project };
        // record project name and drive id for validation later
        $scope.currentProjectName = $scope.projectHash.project.name;
        $scope.currentDriveId = $scope.projectHash.project.drive_root_id;
        $rootScope.rootPath = {
          url: $scope.projectHash.project.drive_root_url,
          id: $scope.projectHash.project.drive_root_id,
        };

        if ($scope.projectHash.project.drive_root_id) {
          GoogleApi.getFolderName($scope.projectHash.project.drive_root_id).then(function (response) {
            $rootScope.rootPath.name = response.result.name;
          });
        }

        $scope.events = $scope.projectHash.project.permitted_events;
        $scope.projectHash.fileId = $scope.projectHash.project.client.drive_root_id;
        $scope.projectHash.project.eta = new Date(moment(response.data.project.eta));
        $rootScope.isPicked = true;
      }, function(error) {
        Project.error(error);
      });
    } else {
      $scope.projectHash = {
        'project': {
          'name': '',
          'project_date': new Date(),
          'eta': new Date(),
          'audit_comment': '',
          'drive_root_id': '',
          'drive_root_url': '',
          'client_id': '',
          'project_type_catalog_id': '',
          'product_catalog_id': '',
          'rape_id': '',
        },
        'fileId': ''
      };
      $rootScope.rootPath = {
        url: '',
        id: '',
      };
    }

    $scope.isNew = function() {
      if($stateParams.projectId) {
        return false;
      }
      return true;
    }

    $scope.searchEmployee = '';
  
    Client.index({params: { per_page: 'all', page: 1}}).then(function(response) {
      $scope.clientList = response.data.clients;
      if($scope.clientList.length > 0 && $scope.isNew())
    {
        $scope.projectHash.project.client_id = $scope.clientList[0].id;
        $scope.selectDriveFileId();
      }
    }, function(error) {
      Client.error(error);
    });
    ProjectTypeCatalog.index({params: {ignore_proyect_invoiced: 1}}).then(function(response) {
      // jscs:disable
      $scope.projectTypeList = response.data.project_types;
      // jscs:enable
    }, function(error) {
      ProjectTypeCatalog.error(error);
    });
    ProductCatalog.index({params: {per_page: 'all'}}).then(function(response) {
      $scope.productList = response.data.products;
    }, function(error) {
      ProductCatalog.error(error);
    });

    Employee.index({params: {by_rape: true, by_status: true, per_page: 'all'}}).then(function(response) {
      $scope.rapeList = response.data.employees;
    },function(error) {
      Employee.error(error);
    });

    Employee.index({params: {by_pm: true, by_status: true, per_page: 'all'}}).then(function(response) {
      $scope.pmList = response.data.employees;
      $scope.pmList.unshift({ id: null, name: 'No Aplica'});
    },function(error) {
      Employee.error(error);
    });

    $scope.selectFolder = function() {
      GoogleApi.pickerApiLoad($scope.projectHash.fileId, 'folder');
    }

    $scope.showComment = function() {
      $rootScope.isPicked = true;
      $scope.projectHash.title = 'Guardar'
      $mdDialog.show({
        controller: $rootScope.CommentCtrl,
        templateUrl: 'views/comment_dialog.html',
        scope: $scope,
        preserveScope: true
      }).then(function(result) {
        $scope.projectHash.project.project_date = result.date;
        $scope.projectHash.project.eta = result.eta;
        $scope.projectHash.project.audit_comment = result.comment;
        $scope.saveProject();
      }, function() {
      });
    }

    $scope.saveProject = function() {
      $rootScope.isPicked = true;
      if($rootScope.rootPath) {
        // jscs:disable
        $scope.projectHash.project.drive_root_id = $rootScope.rootPath.id;
        $scope.projectHash.project.drive_root_url = $rootScope.rootPath.url;
        // jscs:enable
      }
      $scope.projectHash.project = Project.sanitizeParams($scope.projectHash.project);

      if ($scope.projectHash.project.pm_id === undefined) {
        $scope.projectHash.project.pm = null
        $scope.projectHash.project.pm_id = null
      }
      
      Project.save($scope.projectHash).then(function(response) {
        let projectId = response.data.project.id
        if($scope.isNew()) { //new project
          var folderName = response.data.project.project_code + '_' + response.data.project.name;
          GoogleApi.createProjectFolderStructure(folderName, response.data.project.project_code).then(function(response) {
            $scope.projectHash.project.drive_root_id = response.id;
            $scope.projectHash.project.drive_root_url = response.url;
            $scope.projectHash.project.audit_comment = 'Se actualizó la estructura en google drive';
            $scope.projectHash.project.id = projectId
            $scope.saveOrEditProject($scope.projectHash)
          }, function(error) {
            console.log(error);
          });
        } else { // Update
          var savedProject = response.data.project;
          // Check for changes in the project name.
          if (savedProject.name != $scope.currentProjectName && savedProject.drive_root_id == $scope.currentDriveId) {
            GoogleApi.updateFolderName($scope.currentDriveId, savedProject.project_code + '_' + savedProject.name).then(function() {
              toaster.pop('success', 'Drive Actualizado', 'Se actualizo el nombre del proyecto');
            }, function(error) {
              // Error while updating project name.
              Project.error(error);
            });
          }
          // Check for changes in the drive id.
          if (savedProject.drive_root_id != $scope.currentDriveId) {
            GoogleApi.moveProjectFolderStructure(
              $scope.currentDriveId,
              savedProject.drive_root_id,
              savedProject.project_code + '_' + savedProject.name,
              savedProject.project_code
            ).then(function(response) {
              $scope.projectHash.project.drive_root_id = response.project_root_id;
              $scope.projectHash.project.drive_root_url = response.project_root_url;
              GoogleApi.updateFolderName($scope.projectHash.project.drive_root_id, savedProject.project_code + '_' + savedProject.name).then(function() {
                if( savedProject.name != $scope.currentProjectName ){
                  toaster.pop('success', 'Drive Actualizado', 'Se actualizo el nombre del proyecto');
                }
              }, function(error) {
                // Error while updating project name.
                Project.error(error);
              });
              $scope.saveOrEditProject($scope.projectHash)
            }, function(error) {
              Project.error(error);
            })
          }
          $state.go('app.projects.show', { projectId: response.data.project.id });
        }
      }, function(error) {
        Project.error(error);
      });


    };

    $scope.saveOrEditProject = function(project) {
      Project.save(project).then(function(response) {
        $state.go('app.projects.show', { projectId: response.data.project.id });
        $scope.projectHash = {
          'project': {
            'name': '',
            'project_date': new Date(),
            'eta': new Date(),
            'audit_comment': '',
            'drive_root_id': '',
            'drive_root_url': '',
            'client_id': '',
            'project_type_catalog_id': '',
            'product_catalog_id': '',
            'rape_id': '',
          }
        };
      }, function(error) {
        Project.error(error);
      });
    }

    $scope.selectDriveFileId = function() {
      var selectedClient = null;

      for (var i = 0; i < $scope.clientList.length; i++) {
        if ($scope.projectHash.project.client_id + '' === $scope.clientList[i].id + '') {
          selectedClient = $scope.clientList[i];
          break;
        }
      }

      if (!selectedClient) {
        $scope.projectHash.fileId = '';
        $rootScope.rootPath = { url: '', id: '' };
        $rootScope.isPicked = false;
        return;
      }
      $scope.projectHash.fileId = selectedClient.drive_root_id;

      if (selectedClient.project_drive_id) {
        $rootScope.rootPath = {
          id: selectedClient.project_drive_id,
          url: 'https://drive.google.com/drive/folders/' + selectedClient.project_drive_id
        };

        if (selectedClient.project_drive_folder_name) {
          $rootScope.rootPath.name = selectedClient.project_drive_folder_name;
        }

        $rootScope.isPicked = true;

      } else if (selectedClient.drive_root_id && selectedClient.drive_root_url) {
        $rootScope.rootPath = {
          id: selectedClient.drive_root_id,
          url: selectedClient.drive_root_url
        };
        $rootScope.isPicked = true;

      } else {
        $rootScope.rootPath = { url: '', id: '' };
        $rootScope.isPicked = false;
      }
      if ($rootScope.rootPath.id && !$rootScope.rootPath.name) {
        GoogleApi.getFolderName($rootScope.rootPath.id).then(function (response) {
          $rootScope.$applyAsync(function () {
            $rootScope.rootPath.name = response.result.name;
          });
        });
      }
    };

    $scope.checkUrl = function() {
      if($rootScope.rootPath.url.includes("https://drive.google.com/drive/","folders/")) {
        var index = $rootScope.rootPath.url.indexOf("folders/") + 8
        $rootScope.rootPath.id = $rootScope.rootPath.url.substr(index)
      } else {
        var error = {
          status: 422,
          data: {
            errors: {
              base: ['Favor de verificar la ruta del proyecto.']
            }
          }
        }
        Project.error(error);
      }
    };

  }]);
